module.exports = __webpack_public_path__ + "static/media/4.dbb2bc67.jpeg";